import { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-duplicates
import { default as arSALocale } from 'date-fns/locale/ar-SA';
// eslint-disable-next-line import/no-duplicates
import { formatDistance } from 'date-fns';

import { useTranslation } from '@providers/I18n';

export function useTimeDistance(time: Date) {
  const { i18n } = useTranslation();
  const calc = () =>
    formatDistance(time, Date.now(), {
      addSuffix: true,
      locale: i18n.language === 'ar' ? arSALocale : undefined,
    });

  const [distance, setDistance] = useState(() => calc());

  useEffect(() => {
    const interval = setInterval(() => {
      setDistance(calc());
    }, 60000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return distance;
}
